import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import EsApplyProdCateList from '../../components/es/EsApplyProdCateList';
import { getElkCateStatsInfoAction } from '../../modules/common/prodModule';

const EsApplyProdCateContainerBlock = styled.div``;

const EsApplyProdCateContainer = () => {

    const dispatch = useDispatch();

    const { prodStats, error, loading, selectedBrandItem, cateItems } = useSelector(
        ({ prodItemsReducer, brandItemsReducer, cateItemsReducer, loadingReducer }) => ({
            prodStats: prodItemsReducer.prodStats,
            error: prodItemsReducer.error,
            loading: loadingReducer['es/LIST_PROD_STATS'],
            selectedBrandItem: brandItemsReducer.selectedBrandItem,
            cateItems: cateItemsReducer.activeBrandCateIds
        })
    );

    useEffect(() => {
        if (cateItems !== null
            && cateItems !== undefined
            && cateItems.length > 0
            && selectedBrandItem.id !== null
            && selectedBrandItem.id !== 0
        ) {
            dispatch(getElkCateStatsInfoAction(cateItems, selectedBrandItem.id));
        }
    }, [dispatch, cateItems, selectedBrandItem]);

    return (
        <EsApplyProdCateContainerBlock>
            <EsApplyProdCateList loading={loading} error={error} cateinfo={prodStats === null ? null : prodStats.aggs} />
        </EsApplyProdCateContainerBlock>
    );
};

export default EsApplyProdCateContainer;